// What an agent run cost — run.subtasks.<task>.usage, written by the backend's
// subtask_util from agent_harness_bridge.AgentRunOutcome.usage.

const compact = (n) =>
  n >= 1e6 ? `${(n / 1e6).toFixed(1)}M` : n >= 1e3 ? `${Math.round(n / 1e3)}k` : String(n);

export function inputTokens(usage) {
  const parts = [usage?.input_tokens, usage?.cache_read_input_tokens, usage?.cache_creation_input_tokens];
  return parts.some((n) => typeof n === "number") ? parts.reduce((sum, n) => sum + (n || 0), 0) : null;
}

export function formatCost(usd) {
  if (typeof usd !== "number") return null;
  return usd > 0 && usd < 0.01 ? "<$0.01" : `$${usd.toFixed(2)}`;
}

// "$1.10 · 722k in / 10k out tokens · 19 turns · claude-opus-5-5", or null when
// there's nothing to show.
export function formatUsage(usage) {
  if (!usage) return null;
  const input = inputTokens(usage);
  const output = usage.output_tokens;
  const parts = [
    formatCost(usage.cost_usd) || (input != null || output != null ? "cost unknown" : null),
    input != null || typeof output === "number"
      ? `${input != null ? compact(input) : "?"} in / ${typeof output === "number" ? compact(output) : "?"} out tokens`
      : null,
    typeof usage.num_turns === "number" ? `${usage.num_turns} turns` : null,
    usage.model || null,
  ].filter(Boolean);
  return parts.length ? parts.join(" · ") : null;
}

// Sum of every subtask's cost_usd; null when none recorded one.
export function totalCost(subtasks) {
  const costs = Object.values(subtasks || {})
    .map((s) => s?.usage?.cost_usd)
    .filter((c) => typeof c === "number");
  return costs.length ? costs.reduce((a, b) => a + b, 0) : null;
}
